
// @ts-nocheck


export const localeCodes =  [
  "ru"
]

export const localeLoaders = {
  "ru": []
}

export const vueI18nConfigs = [
  () => import("../i18n/i18n.config.ts?hash=5b32d2e0&config=1" /* webpackChunkName: "i18n_config_5b32d2e0" */)
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute",
    "alternateLinkCanonicalQueries": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "ru",
      "name": "Russian"
    }
  ],
  "defaultLocale": "ru",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "donut-locale",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "messages": {
    "ru": {
      "about": {
        "navigation": {
          "contacts": "Контакты",
          "questions": "Как это работает",
          "rates": "Тарифы"
        }
      },
      "auth": {
        "login": {
          "buttonForgotPassword": "Не помню пароль",
          "buttonLogin": "Войти",
          "buttonRegistration": "Зарегистрируйтесь",
          "divider": "или с помощью",
          "haventAccount": "Ещё нет аккаунта?",
          "inputs": {
            "email": {
              "placeholder": "Email"
            },
            "password": {
              "placeholder": "Пароль"
            }
          },
          "title": "Войдите в Donut"
        },
        "newPassword": {
          "buttonCancel": "Отмена",
          "buttonSuccess": "Сохранить",
          "inputs": {
            "password": {
              "placeholder": "Новый пароль"
            },
            "passwordConfirmed": {
              "placeholder": "Повторите новый пароль"
            }
          },
          "title": "Создание нового пароля"
        },
        "registration": {
          "buttonLogin": "Войдите",
          "buttonSuccess": "Зарегистрироваться",
          "description": "Один шаг до пробного бесплатного периода",
          "divider": "или с помощью",
          "haveAccount": "Уже есть аккаунт?",
          "inputs": {
            "email": {
              "placeholder": "Email"
            },
            "password": {
              "placeholder": "Пароль"
            }
          },
          "terms": {
            "link": "Условиями использования",
            "text": "Регистрируясь, вы соглашаетесь с"
          },
          "title": "Зарегистрируйтесь в Donut"
        },
        "remindPassword": {
          "buttonCancel": "Отмена",
          "buttonSuccess": "Отправить",
          "description": "Введите email вашего аккаунта, куда будет отправлена ссылка для создания нового пароля",
          "inputs": {
            "email": {
              "placeholder": "Email"
            }
          },
          "title": "Забыли пароль?"
        }
      },
      "cabinet": {
        "help": "Нужна помощь?",
        "logout": "Выйти",
        "menu": {
          "about": {
            "description": "Информация, тарифы, контакты",
            "name": "Больше о Donut"
          },
          "profile": "Данные аккаунта",
          "projects": "Проекты"
        }
      },
      "common": {
        "becomeClient": "Стать клиентом Donut",
        "moreDetails": "Подробнее",
        "tryFree": "Попробовать бесплатно"
      },
      "contactForm": {
        "email": {
          "placeholder": "Электронная почта"
        },
        "name": {
          "placeholder": "Ваше имя"
        },
        "phone": {
          "placeholder": "Телефон"
        },
        "question": {
          "placeholder": "Ваш вопрос или предложение"
        },
        "submit": "Отправить"
      },
      "cookie": {
        "button": "Понятно",
        "link": "согласие на использование файлов cookie",
        "text": "Продолжая использовать наш сайт, вы даёте"
      },
      "footer": {
        "links": {
          "contacts": "Контакты",
          "questions": "Поддержка",
          "rates": "Тарифы"
        },
        "terms": {
          "cookie": "Использование cookie",
          "licenseAgreement": "Лицензионный договор",
          "privacyPolicy": "Политика конфиденциальности",
          "userAgreement": "Пользовательское соглашение"
        }
      },
      "header": {
        "accordions": {
          "applications": {
            "description": "Предлагайте клиентам любые услуги с&nbsp;быстрой отправкой заявки",
            "name": "Услуги с заявками"
          },
          "bot": {
            "description": "Настраивайте уведомления и&nbsp;автоматические ответы клиенту",
            "name": "Конструктор бота"
          },
          "cabinet": {
            "description": "История всех заказов, записей и&nbsp;заявок в&nbsp;одном удобном профиле",
            "name": "Личный кабинет клиента"
          },
          "chats": {
            "description": "Общайтесь с&nbsp;клиентами из&nbsp;разных мессенджеров в&nbsp;CRM",
            "name": "Чаты с клиентами"
          },
          "crm": {
            "description": "Пользуйтесь понятной и&nbsp;функциональной системой управления",
            "name": "Эффективная CRM"
          },
          "onlineRecord": {
            "description": "Управляйте индивидуальными и&nbsp;групповыми записями всех филиалов через журнал",
            "name": "Онлайн-запись"
          },
          "shop": {
            "description": "Продавайте товары в&nbsp;удобном каталоге с&nbsp;гибкими настройками",
            "name": "Интернет-магазин"
          },
          "website": {
            "description": "Добавьте фирменный цвет и&nbsp;нужную информацию о&nbsp;компании",
            "name": "Конструктор сайта"
          }
        },
        "help": "Нужна помощь?",
        "login": "Войти",
        "menu": {
          "examples": "Примеры",
          "questions": "Поддержка",
          "rates": "Тарифы"
        },
        "notification": {
          "allRead": "Все прочитано",
          "empty": "Новых уведомлений нет",
          "title": "Уведомления"
        },
        "possibilities": "Возможности",
        "registration": "Зарегистрироваться"
      },
      "knowledgeBaseBlock": {
        "button": "Перейти в базу знаний",
        "description": "Всё, что нужно знать о&nbsp;нашем сервисе",
        "title": "База знаний Donut"
      },
      "notifications": {
        "deleteAccount": "Вы удалили свой аккаунт",
        "letterSubmit": "Вы удалили свой аккаунт",
        "messageSubmit": "Ваше сообщение успешно отправлено!",
        "passwordSaved": "Пароль сохранен! Теперь вы можете входить с его помощью в свой аккаунт",
        "passwordSaveSuccess": "Пароль сохранен! Теперь вы можете входить с его помощью в свой аккаунт",
        "profileUpdate": "Профиль обновлен!",
        "sendPasswordRemindLetter": "Письмо с ссылкой на восстановление пароля отправлено"
      },
      "pages": {
        "client": {
          "contacts": {
            "email": {
              "label": "Почта"
            },
            "headerTitle": "Все наши контакты&nbsp;здесь",
            "inputs": {
              "email": {
                "placeholder": "Email"
              },
              "name": {
                "placeholder": "Ваше имя"
              },
              "phone": {
                "placeholder": "Телефон"
              },
              "question": {
                "placeholder": "Ваш вопрос"
              },
              "submitButton": "Отправить"
            },
            "orderForm": {
              "description": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
              "title": "Остались вопросы?"
            },
            "seo": {
              "title": "Контакты"
            },
            "social": {
              "label": "Социальные сети"
            },
            "telegram": {
              "label": "Telegram"
            },
            "title": "Нас легко найти"
          },
          "profile": {
            "basicInfo": {
              "inputs": {
                "avatar": {
                  "deleteButtonText": "Удалить",
                  "hint": "Jpeg, Jpg, Png, максимальный размер файла 5 Мб",
                  "label": "Фотография",
                  "placeholder": "Загрузить изображение"
                },
                "country": {
                  "label": "Страна",
                  "placeholder": "Выберите страну"
                },
                "language": {
                  "label": "Язык",
                  "placeholder": "Выберите язык"
                },
                "name": {
                  "label": "Имя",
                  "placeholder": "Ваше имя"
                },
                "phone": {
                  "label": "Телефон",
                  "placeholder": "Ваш телефон"
                },
                "surname": {
                  "label": "Фамилия",
                  "placeholder": "Ваша фамилия"
                },
                "timezone": {
                  "label": "Часовой пояс",
                  "placeholder": "Выберите часовой пояс аккаунта"
                }
              },
              "title": "Основная информация"
            },
            "delete": {
              "button": "Удалить",
              "description": "При удалении аккаунта все данные будут невозвратно потеряны",
              "title": "Удаление аккаунта"
            },
            "entrySection": {
              "confirm": "Подтвердите почту по ссылке из письма!",
              "confirmNewLink": "Получить новую ссылку",
              "header": "Данные аккаунта",
              "inputs": {
                "email": {
                  "label": "Электронная почта"
                },
                "newPassword": {
                  "label": "Новый пароль",
                  "placeholder": "Ваш новый пароль"
                },
                "passwordConfirm": {
                  "label": "Подтвердите пароль",
                  "placeholder": "Подтвердите ваш новый пароль"
                }
              }
            },
            "notifications": {
              "successSubmit": "Письмо отправлено на вашу почту!"
            },
            "passwordSection": {
              "inputs": {
                "currentPassword": {
                  "placeholder": "Ваш текущий пароль"
                },
                "newPassword": {
                  "placeholder": "Ваш новый пароль"
                },
                "passwordConfirm": {
                  "placeholder": "Повторите новый пароль"
                }
              },
              "titleHasPassword": "Изменение пароля",
              "titleNeedPassword": "Сменить пароль"
            },
            "seo": {
              "title": "Профиль"
            },
            "social": {
              "title": "Социальные сети"
            },
            "submitButton": "Сохранить",
            "title": "Данные аккаунта"
          },
          "projects": {
            "emptyData": {
              "needConfirmation": {
                "button": "Получить новую ссылку",
                "description": "На email, введенный при регистрации, была отправлена ссылка для подтверждения. Перейдите по ней или запросите ниже новую",
                "title": "Подтвердите аккаунт"
              },
              "withProjects": {
                "button": "Добавить проект",
                "description": "Пока здесь пусто",
                "title": "Создайте свой первый проект"
              }
            },
            "header": {
              "addProject": "Добавить проект",
              "title": "Проекты"
            },
            "notifications": {
              "linkCopied": "Ссылка скопирована"
            },
            "seo": {
              "title": "Проекты"
            }
          },
          "questions": {
            "title": "Поможем разобраться"
          },
          "rates": {
            "comparison": "Сравните функции тарифов",
            "questions": "Популярные вопросы",
            "seo": {
              "title": "Тарифные планы"
            },
            "title": "Тарифный план для каждого"
          }
        },
        "contacts": {
          "email": {
            "label": "Почта"
          },
          "headerTitle": "Все наши контакты&nbsp;здесь",
          "orderForm": {
            "description": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "title": "Есть вопросы или&nbsp;предложения?"
          },
          "seo": {
            "title": "Контакты"
          },
          "social": {
            "label": "Социальные сети"
          },
          "telegram": {
            "label": "Telegram"
          }
        },
        "cookies": {
          "agreement": "Используя этот сайт, вы автоматически соглашаетесь с обработкой указанных данных. Вы можете отключить cookies в настройках браузера или прекратить использование сайта, если не согласны с этой политикой. Обратите внимание, что отключение некоторых типов файлов cookie может привести к ограничению доступа к некоторым функциям нашего сайта.",
          "analytics": "Для анализа применяются инструменты Google Analytics.",
          "collectedInformation": "Собираемая информация включает:",
          "headerTitle": "Использование cookie",
          "informationTypes": {
            "browserData": "Данные браузера и операционной системы",
            "browsingHistory": "История просмотров страниц",
            "deviceParameters": "Технические параметры устройства",
            "ipAddress": "IP-адрес",
            "localStorage": "Локальное хранилище браузера",
            "location": "Местоположение",
            "messengerTracking": "Технологии отслеживания в мессенджерах",
            "otherTechnologies": "Другие подобные технологии",
            "referralSource": "Источник перехода на сайт",
            "webBeacons": "Веб-маяки (пиксельные теги)"
          },
          "orderForm": {
            "description": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "title": "Есть вопросы или&nbsp;предложения?"
          },
          "purposes": {
            "analyzingVisitors": "Анализа поведения посетителей",
            "ensuringCorrectOperation": "Обеспечения корректной работы всех функций",
            "ensuringSecurity": "Обеспечения безопасности",
            "improvingService": "Улучшения качества обслуживания",
            "personalizingContent": "Персонализации контента"
          },
          "seo": {
            "title": "Использование cookie"
          },
          "weUse": "Мы используем файлы cookie и собираем данные о вашем взаимодействии с сайтом для:"
        },
        "faq": {
          "backToCategory": "Вернуться в категорию",
          "dislike": "Не помогло",
          "empty": "Статья находится в разработке",
          "index": {
            "backToMainSite": "Перейти на&nbsp;основной сайт",
            "header": {
              "description": "База знаний Donut. Всё, что нужно знать о&nbsp;нашем сервисе",
              "title": "Нужна помощь?"
            },
            "sections": {
              "popularArticles": "Популярные статьи",
              "topicalAnswers": "Ответы по теме"
            },
            "seo": {
              "title": "База знаний"
            }
          },
          "inThisArticle": "В этой статье",
          "like": "Было полезно",
          "otherArticles": "Другие статьи по&nbsp;этой теме",
          "search": {
            "emptyPlaceholder": "К сожалению, мы ничего не смогли найти. Уточните поисковой запрос.",
            "placeholder": "Поиск по базе знаний"
          },
          "thankYouForRating": "Спасибо за отзыв!",
          "title": "База знаний"
        },
        "features": {
          "applications": {
            "businesses": {
              "lawyer": "Адвокат",
              "nutritionist": "Нутрициолог",
              "photographer": "Фотограф",
              "trainer": "Тренер",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "applicationsManagement": {
                "description": "Управление заявками и&nbsp;их&nbsp;статусами через продуманную систему",
                "title": "Заявки"
              },
              "catalog": {
                "description": "Гибкая настройка категорий с&nbsp;отдельными фильтрами в&nbsp;каталоге",
                "title": "Каталог"
              },
              "clientNotifications": {
                "description": "Извещение клиентов о&nbsp;смене статусов заявок",
                "title": "Уведомления клиентов"
              },
              "onlineRecord": {
                "description": "Возможность одной кнопкой переключить услугу на&nbsp;онлайн-&#65279;запись",
                "title": "Онлайн-запись"
              }
            },
            "headerTitle": "Получение заявок на&nbsp;услуги",
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "sectionCard": {
              "description": "Получение заявок на&nbsp;услуги с&nbsp;возможностью в&nbsp;любой момент переключить их&nbsp;на&nbsp;онлайн-запись",
              "title": "Юридическая помощь"
            },
            "seo": {
              "title": "Услуги с заявками"
            }
          },
          "bot": {
            "businesses": {
              "barbershop": "Барбершоп",
              "beautySalon": "Салон красоты",
              "billiardRoom": "Бильярдная",
              "carWash": "Автомойка",
              "clothingStore": "Магазин одежды",
              "fitness": "Фитнес",
              "lawyer": "Адвокат",
              "notary": "Нотариус",
              "photoStudio": "Фотостудия",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "easyConnection": {
                "description": "Помощь с&nbsp;созданием и&nbsp;подключение вашего бота в&nbsp;пару кликов",
                "title": "Легкое подключение"
              },
              "notifications": {
                "description": "Настройка активности и&nbsp;текстов в&nbsp;автоматических уведомлениях",
                "title": "Уведомления"
              }
            },
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "settings": {
              "answers": {
                "description": "Настройка текстов в&nbsp;автоматических ответах",
                "title": "Ответы"
              },
              "commands": {
                "description": "Настройка главных команд бота",
                "title": "Команды"
              }
            },
            "title": "Конструктор бота"
          },
          "chats": {
            "businesses": {
              "barbershop": "Барбершоп",
              "beautySalon": "Салон красоты",
              "billiardRoom": "Бильярдная",
              "carWash": "Автомойка",
              "clothingStore": "Магазин одежды",
              "fitness": "Фитнес",
              "lawyer": "Адвокат",
              "notary": "Нотариус",
              "photoStudio": "Фотостудия",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "automation": {
                "description": "Настройка автоматических ответов на&nbsp;популярные вопросы",
                "title": "Автоматизация"
              },
              "chatsCrm": {
                "description": "Общение со&nbsp;всеми клиентами в&nbsp;одном месте",
                "title": "Чаты в CRM"
              },
              "messengers": {
                "description": "Поддержка разных мессенджеров и&nbsp;социальных сетей",
                "title": "Мессенджеры"
              },
              "quickActions": {
                "description": "Создание записей, заказов и&nbsp;заявок клиенту прямо из&nbsp;чата",
                "title": "Быстрые действия"
              }
            },
            "headerTitle": "Чаты с&nbsp;клиентами",
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "seo": {
              "title": "Чаты с клиентами"
            }
          },
          "clientCabinet": {
            "businesses": {
              "barbershop": "Барбершоп",
              "beautySalon": "Салон красоты",
              "billiardRoom": "Бильярдная",
              "carWash": "Автомойка",
              "clothingStore": "Магазин одежды",
              "fitness": "Фитнес",
              "lawyer": "Адвокат",
              "notary": "Нотариус",
              "photoStudio": "Фотостудия",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "notifications": {
                "description": "Настройка клиентом желаемых уведомлений",
                "title": "Уведомления"
              },
              "orderHistory": {
                "description": "Просмотр и&nbsp;управление всеми записями, заказами и&nbsp;заявками",
                "title": "История заказов"
              },
              "personalDiscounts": {
                "description": "Возможность присвоить клиенту персональную скидку",
                "title": "Персональные скидки"
              },
              "quickRegistration": {
                "description": "Создание аккаунта при входе через мессенджер",
                "title": "Быстрая регистрация"
              }
            },
            "headerTitle": "Личный кабинет клиента",
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "seo": {
              "title": "Личный кабинет клиента"
            }
          },
          "crm": {
            "businesses": {
              "barbershop": "Барбершоп",
              "beautySalon": "Салон красоты",
              "billiardRoom": "Бильярдная",
              "carWash": "Автомойка",
              "clothingStore": "Магазин одежды",
              "fitness": "Фитнес",
              "lawyer": "Адвокат",
              "notary": "Нотариус",
              "photoStudio": "Фотостудия",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "appointmentJournal": {
                "description": "Записи всех филиалов в&nbsp;одном продуманном журнале",
                "title": "Журнал записи"
              },
              "clients": {
                "description": "Общение с&nbsp;клиентами в&nbsp;чате, уведомления и&nbsp;персональные скидки",
                "title": "Клиенты"
              },
              "employees": {
                "description": "Гибко настраиваемое рабочее расписание сотрудников",
                "title": "Сотрудники"
              },
              "inOnePlace": {
                "description": "Управление записями, заказами и&nbsp;заявками из&nbsp;одной системы",
                "title": "В одном месте"
              },
              "reports": {
                "description": "Получайте статистику по&nbsp;нужным параметрам и&nbsp;анализируйте",
                "title": "Отчёты"
              }
            },
            "headerTitle": "Система управления",
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "seo": {
              "title": "Эффективная CRM"
            }
          },
          "onlineRecord": {
            "businesses": {
              "beautySalon": "Салон красоты",
              "photoStudio": "Фотостудия",
              "restaurant": "Ресторан",
              "tutor": "Репетитор",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "appointmentJournal": {
                "description": "Управление записями всех филиалов через продуманный журнал",
                "title": "Журнал записи"
              },
              "appointmentTypes": {
                "description": "Индивидуальные или групповые записи для любых целей",
                "title": "Типы записей"
              },
              "clientNotifications": {
                "description": "Напоминания клиентам о&nbsp;предстоящих записях, переносах или отменах",
                "title": "Уведомления клиентов"
              },
              "versatility": {
                "description": "Настройка и&nbsp;добавление новой записи по&nbsp;филиалу, сотруднику, услуге и&nbsp;времени",
                "title": "Универсальность"
              },
              "workSchedule": {
                "description": "Гибко настраиваемое рабочее расписание сотрудников",
                "title": "Расписание работы"
              }
            },
            "headerTitle": "Онлайн-запись на&nbsp;услуги",
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "sectionCard": {
              "description": "Запись на&nbsp;одиночные или групповые услуги с&nbsp;учетом рабочего графика ваших сотрудников",
              "title": "Барбершоп"
            },
            "seo": {
              "title": "Онлайн-запись"
            }
          },
          "shop": {
            "businesses": {
              "autoparts": "Автозапчасти",
              "clothing": "Одежда",
              "cosmetics": "Косметика",
              "dishes": "Посуда",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "catalog": {
                "description": "Гибкая настройка категорий с&nbsp;отдельными фильтрами в&nbsp;каталоге",
                "title": "Каталог"
              },
              "clientNotifications": {
                "description": "Извещение клиентов о&nbsp;смене статусов заказов и&nbsp;другие настраиваемые уведомления",
                "title": "Уведомления клиентов"
              },
              "deliveryTypes": {
                "description": "Добавление настраиваемых типов доставки и&nbsp;их&nbsp;выбор для нужных товаров",
                "title": "Типы доставки"
              },
              "orders": {
                "description": "Управление заказами и&nbsp;их&nbsp;статусами через продуманную систему",
                "title": "Заказы"
              },
              "products": {
                "description": "Товары и&nbsp;их&nbsp;варианты по&nbsp;любым параметрам с&nbsp;подсчётом остатков",
                "title": "Товары"
              }
            },
            "headerTitle": "Продажа товаров в&nbsp;интернет-&#65279;магазине",
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "sectionCard": {
              "description": "Продажа в&nbsp;каталоге с&nbsp;настраиваемыми фильтрами категорий и&nbsp;вариантами товаров по&nbsp;нужным параметрам",
              "title": "Магазин одежды"
            },
            "seo": {
              "title": "Интернет-магазин"
            }
          },
          "website": {
            "businesses": {
              "barber": "Барбершоп",
              "beautySalon": "Салон красоты",
              "billiards": "Бильярдная",
              "carWash": "Автомойка",
              "clothingStore": "Магазин одежды",
              "fitness": "Фитнес",
              "lawyer": "Адвокат",
              "notary": "Нотариус",
              "photoStudio": "Фотостудия",
              "yourBusiness": "Ваш бизнес"
            },
            "cards": {
              "management": {
                "description": "Возможность поменять названия или вид разных элементов",
                "title": "Управление"
              },
              "oneColor": {
                "description": "Настройка всего дизайна под фирменный стиль одним цветом",
                "title": "Один цвет"
              },
              "pages": {
                "description": "Создание кастомных страниц с&nbsp;дополнительной информацией",
                "title": "Страницы"
              },
              "simple": {
                "description": "Автоматическое создание сайта в&nbsp;зависимости от&nbsp;контента",
                "title": "Всё просто"
              }
            },
            "headerTitle": "Конструктор сайта",
            "managerDescription": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "questionsTitle": "Остались вопросы или&nbsp;нужна помощь?",
            "seo": {
              "title": "Конструктор сайта"
            }
          }
        },
        "index": {
          "approach": {
            "subtitle": "Система управления со всем самым нужным перед глазами",
            "title": "Продуманный <br /> и понятный подход"
          },
          "bonuses": {
            "items": {
              "earnings": {
                "description": "Создайте свой сайт-приложение для быстрой продажи товаров и&nbsp;простой онлайн-записи на&nbsp;услуги",
                "title": "Зарабатывайте больше"
              },
              "efficiency": {
                "description": "Управляйте продажами, записями и&nbsp;чатами через CRM-систему даже со&nbsp;смартфона",
                "title": "Повышайте эффективность"
              },
              "visibility": {
                "description": "Сайт будет доступен как встроенное приложение в&nbsp;мессенджерах или&nbsp;по&nbsp;прямой&nbsp;ссылке",
                "title": "Будьте заметнее"
              }
            }
          },
          "businesses": {
            "beautySalon": "Салон красоты",
            "billiards": "Бильярдная",
            "carWash": "Автомойка",
            "clothingStore": "Магазин одежды",
            "fitness": "Фитнес",
            "lawyer": "Адвокат",
            "notary": "Нотариус",
            "photoStudio": "Фотостудия",
            "restaurant": "Ресторан",
            "title": "Используйте в&nbsp;любом&nbsp;бизнесе",
            "yourBusiness": "Ваш бизнес"
          },
          "cards": {
            "first": {
              "chats": {
                "description": "Общайтесь с&nbsp;клиентами из&nbsp;разных мессенджеров в&nbsp;CRM, а&nbsp;бот поможет ответить на&nbsp;самые популярные вопросы за&nbsp;менеджера",
                "title": "Чаты с клиентами"
              },
              "crm": {
                "description": "Пользуйтесь понятной и&nbsp;функциональной системой управления вашими заказами, записями и&nbsp;заявками",
                "title": "Эффективная CRM"
              },
              "onlineRecord": {
                "description": "Управляйте индивидуальными и&nbsp;групповыми записями всех филиалов через журнал, а&nbsp;рабочее расписание сотрудников повысит эффективность и&nbsp;прозрачность работы",
                "title": "Онлайн-запись"
              },
              "services": {
                "description": "Предлагайте клиентам любые услуги с&nbsp;быстрой отправкой заявки, а&nbsp;при необходимости включите для них расписание и&nbsp;онлайн-запись",
                "title": "Услуги с заявками"
              },
              "shop": {
                "description": "Продавайте товары в&nbsp;удобном каталоге с&nbsp;гибкими настройками, а&nbsp;наша CRM не&nbsp;даст потеряться ни&nbsp;одному заказу и&nbsp;посчитает все остатки на&nbsp;складе",
                "title": "Интернет-магазин"
              }
            },
            "second": {
              "bot": {
                "description": "Лёгкое подключение бота с&nbsp;настройкой автоматических ответов клиенту, уведомлений и&nbsp;команд",
                "title": "Конструктор бота"
              },
              "cabinet": {
                "description": "История всех заказов, записей и&nbsp;заявок в&nbsp;одном удобном профиле с&nbsp;отслеживанием статусов и&nbsp;персональными скидками",
                "title": "Личный кабинет клиента"
              },
              "website": {
                "description": "Мы&nbsp;продумали почти все&nbsp;&mdash; останется только настроить фирменный цвет и&nbsp;добавить нужную информацию о&nbsp;компании",
                "title": "Конструктор сайта"
              }
            }
          },
          "features": {
            "subtitle": "Если не&nbsp;найдете нужный функционал&nbsp;&mdash; мы&nbsp;его добавим!",
            "title": "Один Donut, <br /> множество возможностей"
          },
          "header": {
            "subtitle": "Сервис для автоматизации бизнеса",
            "title": "Онлайн запись, товары и&nbsp;услуги через мессенджер"
          },
          "integration": {
            "subtitle": "Поможем с&nbsp;интеграцией на&nbsp;всех этапах",
            "title": "Внедрите Donut<br />в&nbsp;бизнес всего за&nbsp;4&nbsp;шага"
          },
          "quickBuy": {
            "platforms": "Поддерживаемые платформы",
            "subtitle": "Система управления со всем самым нужным перед глазами",
            "title": "Быстрая покупка <br /> или запись через мессенджер"
          },
          "sectionCards": {
            "barbershop": {
              "description": "Запись на&nbsp;одиночные или групповые услуги с&nbsp;учётом рабочего графика ваших сотрудников",
              "title": "Барбершоп"
            },
            "clothing": {
              "description": "Продажа в&nbsp;каталоге с&nbsp;настраиваемыми фильтрами категорий и&nbsp;вариантами товаров по&nbsp;нужным параметрам",
              "title": "Магазин одежды"
            },
            "legal": {
              "description": "Получение заявок на&nbsp;услуги с&nbsp;возможностью в&nbsp;любой момент переключить их&nbsp;на&nbsp;онлайн-запись",
              "title": "Юридическая помощь"
            }
          },
          "steps": {
            "data": {
              "description": "Поможем с&nbsp;заполнением каталога товаров и&nbsp;услуг, онлайн-расписанием сотрудников",
              "title": "Расскажем как перенести данные"
            },
            "instructions": {
              "description": "Избавим ваших сотрудников от&nbsp;долгого изучения работы системы",
              "title": "Выдадим&nbsp;инструкции для сотрудников"
            },
            "needs": {
              "description": "Расскажем про весь функционал сервиса, который может быть вам полезен",
              "title": "Узнаем ваши потребности"
            },
            "setup": {
              "description": "Покажем как всё работает и&nbsp;как быстро настроить CRM под ваши потребности",
              "title": "Поможем настроить сервис под вас"
            },
            "step_number": "Шаг {number}"
          }
        },
        "questions": {
          "contact": {
            "description": "Напишите нам. Менеджер скоро с&nbsp;вами свяжется",
            "title": "Остались вопросы или&nbsp;нужна помощь?"
          },
          "headerTitle": "Поможем разобраться",
          "list": {
            "1": {
              "answer": "Donut - это инновационная платформа для создания бизнес-приложений в мессенджерах. Она объединяет в себе:<br><br>\n  &nbsp;&nbsp;•&nbsp;&nbsp;Конструктор сайтов, адаптированных под популярные мессенджеры<br>\n  &nbsp;&nbsp;•&nbsp;&nbsp;Систему онлайн-записи и каталогизации товаров/услуг<br>\n  &nbsp;&nbsp;•&nbsp;&nbsp;Автоматизированного бота для общения с клиентами<br>\n  &nbsp;&nbsp;•&nbsp;&nbsp;Встроенную CRM-систему для эффективного управления бизнесом<br><br>\nВсё это работает как единая экосистема, позволяя вашему бизнесу быть там, где находятся ваши клиенты - в мессенджерах.",
              "title": "Что такое Donut?"
            },
            "2": {
              "answer": "Donut создан для бизнеса любого масштаба, который хочет эффективно взаимодействовать с клиентами в мессенджерах:<br><br>\n            &nbsp;&nbsp;•&nbsp;&nbsp;Сфера красоты и здоровья: салоны красоты, спа-центры, фитнес-клубы<br>\n              &nbsp;&nbsp;•&nbsp;&nbsp;Розничная торговля: интернет-магазины, шоурумы, бутики<br>\n              &nbsp;&nbsp;•&nbsp;&nbsp;Сфера услуг: ремонт, клининг, доставка<br>\n              &nbsp;&nbsp;•&nbsp;&nbsp;Образование: школы, курсы, репетиторы<br>\n              &nbsp;&nbsp;•&nbsp;&nbsp;Медицина: частные клиники, стоматологии, консультации<br>\n              &nbsp;&nbsp;•&nbsp;&nbsp;Развлечения: рестораны, кафе, event-агентства<br><br>\n            Особенно платформа будет полезна тем, кто хочет автоматизировать работу с клиентами и добавить бизнес-процессы в популярные мессенджеры.",
              "title": "Кому подойдет использование Donut?"
            },
            "3": {
              "answer": "Donut — это больше, чем просто сайт в мессенджере. Это полноценная CRM-система для управления вашим бизнесом, интегрированная с популярными мессенджерами, где сегодня находится большинство клиентов. В отличие от обычных сайтов, каждый посетитель автоматически становится потенциальным клиентом — его контакты сохраняются, и вы можете продолжить общение даже после его ухода.<br><br>\n            Встроенный бот берет на себя рутинные задачи: отвечает на типовые вопросы, принимает заказы и записи, отправляет уведомления. Это значительно снижает нагрузку на ваших менеджеров и обеспечивает мгновенную реакцию на запросы клиентов в любое время суток. При этом вам не нужно разрабатывать и поддерживать отдельные приложения для App Store или Google Play — всё работает через привычные мессенджеры на любых устройствах.",
              "title": "Почему вам стоит использовать Donut?"
            },
            "4": {
              "answer": "Главное преимущество для ваших клиентов — максимальное удобство. Им не нужно устанавливать новые приложения или запоминать адреса сайтов — всё происходит в привычном мессенджере. Здесь они могут посмотреть ваши товары и услуги, сделать заказ или записаться на прием, получить консультацию и следить за статусом своего заказа.<br><br>\n            Вся история общения, заказов и записей автоматически сохраняется в чате и доступна с любого устройства. А благодаря мгновенным уведомлениям в мессенджере, клиенты всегда в курсе важных событий: подтверждения записи, напоминания о визите или информации о специальных предложениях.",
              "title": "Какие выгоды получат ваши клиенты?"
            },
            "5": {
              "answer": "Donut уникален тем, что объединяет все необходимые инструменты для ведения бизнеса в мессенджерах в одном сервисе. В отличие от других платформ, которые предлагают либо создание ботов, либо CRM-систему, либо конструктор сайтов — Donut предоставляет полноценную экосистему. Здесь есть всё: от создания сайта в мессенджерах до управления клиентской базой, от автоматизации общения до аналитики продаж. При этом платформа остается простой в использовании и не требует технических навыков.",
              "title": "Чем Donut отличается от других сервисов?"
            },
            "6": {
              "answer": "Запустить свой проект в Donut можно за несколько часов, даже если у вас нет технических навыков. Мы создали интуитивно понятный интерфейс, где каждый шаг создания проекта логичен и прост.<br><br>\n            Чтобы вы могли быстро освоиться, мы разработали пошаговые обучающие подсказки прямо в интерфейсе и создали подробную базу знаний. А если возникнут вопросы — наша служба поддержки всегда готова помочь.",
              "title": "Сколько времени займет создания сайта и бота?"
            },
            "7": {
              "answer": "Мы предоставляем бесплатный 14-дневный период, чтобы вы могли полноценно протестировать все возможности сервиса. За это время вы сможете создать свой проект, оценить функционал и выбрать подходящий тариф для ваших задач. Актуальные цены и описание тарифов вы можете посмотреть на странице <a class=\"ui-link-secondary\" href='/client/about/rates'>тарифов</a>.",
              "title": "Сколько стоит использование Donut?"
            },
            "8": {
              "answer": "Связаться с командой поддержки можно через электронную почту, чат на сайте, а также через мессенджеры, если это предусмотрено вашим тарифным планом. Для более оперативного решения вопросов рекомендуется использовать приоритетную поддержку или персонального менеджера.",
              "title": "Как связаться с командой поддержки?"
            }
          },
          "seo": {
            "title": "Вопросы и ответы"
          }
        },
        "rates": {
          "comparison": {
            "title": "Сравните функции&nbsp;тарифов"
          },
          "contactForm": {
            "description": "Напишите нам для подбора персональных условий",
            "title": "Не нашли подходящий&nbsp;тариф?"
          },
          "faq": {
            "title": "Популярные вопросы"
          },
          "headerTitle": "Тарифный план для каждого",
          "seo": {
            "title": "Тарифы"
          }
        }
      },
      "profileDeleteModal": {
        "buttonCancel": "Отмена",
        "buttonSuccess": "Удалить",
        "description": "Вы уверены, что хотите удалить аккаунт? Все данные будут невозвратно потеряны.",
        "input": {
          "placeholder": "Ваш пароль"
        },
        "text": "Введите ваш пароль для подтверждения",
        "title": "Удалить аккаунт?"
      },
      "projectCreateModal": {
        "baseTitle": "Основная информация",
        "buttonCancel": "Отмена",
        "buttonSuccess": "Добавить",
        "description": "Заполните информацию и&nbsp;выберите нужный для отображения функционал. Позже вы&nbsp;сможете изменить эти параметры",
        "inputs": {
          "currencyId": {
            "placeholder": "Валюта проекта"
          },
          "directionId": {
            "placeholder": "Направление деятельности проекта"
          },
          "name": {
            "placeholder": "Название проекта"
          },
          "showed": {
            "prefix": "не",
            "text": "отображаются"
          }
        },
        "menu": {
          "products": {
            "description": "Разделы с товарами и заказами",
            "title": "Товары"
          },
          "services": {
            "description": "Разделы с услугами и заявками",
            "title": "Услуги"
          }
        },
        "phrases": {
          "connect": "Подключаемся",
          "create": "Создаём проект",
          "load": "Загружаем данные"
        },
        "title": "Добавление нового проекта"
      },
      "rates": {
        "annualPayment": "при оплате за год",
        "comparison": {
          "activeChats": {
            "description": "Без учёта архивных",
            "title": "Активных чатов"
          },
          "cost": "Стоимость",
          "donutAds": "Реклама Donut",
          "employees": "Сотрудников",
          "features": "Функции",
          "monthlyPayment": "Оплата за месяц",
          "productsAndServices": "Товаров и услуг",
          "storage": {
            "description": "Для файлов из&nbsp;чата и&nbsp;другого",
            "title": "Хранилище, Гб"
          },
          "support": "Поддержка",
          "yearlyPayment": "Оплата за год"
        },
        "customParameters": "в зависимости от выбранных параметров",
        "or": "или",
        "plans": {
          "base": {
            "advantages": {
              "activeChats": "100 активных чатов",
              "advertising": "Реклама сервиса Donut",
              "employee": "1 сотрудник",
              "products": "30 товаров и 30 услуг",
              "storage": "25 Гб хранилища",
              "support": "Базовая поддержка"
            },
            "button": "Попробовать бесплатно",
            "description": "Всё необходимое для успешной работы профессионала",
            "donutAds": "Есть",
            "name": "Base",
            "price": {
              "annual": "$12 / мес",
              "monthly": "$15 / мес"
            },
            "support": "Базовая"
          },
          "enterprise": {
            "advantages": {
              "advertising": "Нет рекламы сервиса Donut",
              "development": "Услуги по разработке",
              "integrations": "Дополнительные интеграции",
              "limits": "Индивидуальные лимиты",
              "manager": "Персональный менеджер"
            },
            "button": "Оставить заявку",
            "description": "Индивидуальные решения, поддержка и интеграции",
            "name": "Enterprise",
            "price": {
              "custom": "Договорная стоимость"
            },
            "requestButton": "Оставить заявку"
          },
          "large": {
            "advantages": {
              "advertising": "Нет рекламы сервиса Donut",
              "chats": "1 000 активных чатов",
              "employees": "15 сотрудников",
              "products": "2 000 товаров и 2 000 услуг",
              "storage": "300 Гб хранилища",
              "support": "Приоритетная поддержка"
            },
            "button": "Попробовать бесплатно",
            "description": "Для крупных компаний с большими объёмами товаров или услуг",
            "donutAds": "Нет",
            "name": "Large",
            "price": {
              "annual": "$60 / мес",
              "monthly": "$75 / мес"
            },
            "support": "Приоритетная"
          },
          "medium": {
            "advantages": {
              "advertising": "Нет рекламы сервиса Donut",
              "chats": "600 активных чатов",
              "employees": "10 сотрудников",
              "products": "1 000 товаров и 1 000 услуг",
              "storage": "150 Гб хранилища",
              "support": "Приоритетная поддержка"
            },
            "button": "Попробовать бесплатно",
            "description": "Оптимальный выбор для среднего бизнеса с расширенными лимитами",
            "donutAds": "Нет",
            "name": "Medium",
            "price": {
              "annual": "$40 / мес",
              "monthly": "$50 / мес"
            },
            "support": "Приоритетная"
          },
          "small": {
            "advantages": {
              "advertising": "Нет рекламы сервиса Donut",
              "chats": "300 активных чатов",
              "employees": "5 сотрудников",
              "products": "100 товаров и 100 услуг",
              "storage": "50 Гб хранилища",
              "support": "Приоритетная поддержка"
            },
            "button": "Попробовать бесплатно",
            "description": "Идеально для малого бизнеса с приоритетной поддержкой",
            "donutAds": "Нет",
            "name": "Small",
            "price": {
              "annual": "$20 / мес",
              "monthly": "$25 / мес"
            },
            "support": "Приоритетная"
          },
          "ultimate": {
            "advantages": {
              "advertising": "Нет рекламы сервиса Donut",
              "chats": "1 500 активных чатов",
              "employees": "20 сотрудников",
              "manager": "Персональный менеджер",
              "products": "4 000 товаров и 4 000 услуг",
              "storage": "500 Гб хранилища"
            },
            "button": "Попробовать бесплатно",
            "description": "Максимальные возможности и персональный менеджер",
            "donutAds": "Нет",
            "name": "Ultimate",
            "price": {
              "annual": "$80 / мес",
              "monthly": "$100 / мес"
            },
            "support": "Персональный менеджер"
          }
        },
        "questions": {
          "activeChat": {
            "answer": "Это функционал, позволяющий вести диалог с&nbsp;клиентами в&nbsp;реальном времени через различные мессенджеры. Активные чаты включают все текущие чаты-&#65279;переписки (чаты в&nbsp;статусе &laquo;Ждут ответа&raquo; или &laquo;Отвечено&raquo;), т.е. только те&nbsp;чаты, в&nbsp;которых ведется активная переписка.",
            "title": "Что такое активный чат?"
          },
          "advertising": {
            "answer": "Реклама включает размещение рекламных материалов и&nbsp;баннеров, информирующих ваших клиентов о&nbsp;том, что вы&nbsp;используете сервис Donut. Это может быть отключено в&nbsp;определённых тарифах.",
            "title": "Что такое реклама сервиса Donut?"
          },
          "differences": {
            "answer": "Donut предлагает уникальный набор функций: создание сайта, который открывается в&nbsp;различных мессенджерах, одновременно поддерживая чат с&nbsp;клиентом с&nbsp;полноценным CRM для управления бизнесом. Платформа ориентирована на&nbsp;удобство и&nbsp;простоту использования, при этом покрывая необходимые требования бизнеса.",
            "title": "Чем Donut отличается от&nbsp;других сервисов?"
          },
          "enterprise": {
            "answer": "Подойдёт крупным компаниям и&nbsp;организациям, которым требуется максимальный функционал, расширенные возможности интеграции и&nbsp;персонализированная поддержка. Этот тариф предлагает высокую степень кастомизации и&nbsp;индивидуальный подход к&nbsp;каждому клиенту.",
            "title": "Кому подойдёт Enterprise тариф?"
          },
          "storage": {
            "answer": "Это облачное пространство, предназначенное для хранения данных вашего проекта, таких как файлы, изображения, документы и&nbsp;прочие материалы, необходимые для работы с&nbsp;сервисом.",
            "title": "Что такое хранилище?"
          },
          "support": {
            "answer": "Связаться с&nbsp;командой поддержки можно через электронную почту, чат на&nbsp;сайте, а&nbsp;также через мессенджеры, если это предусмотрено вашим тарифным планом. Для более оперативного решения вопросов рекомендуется использовать приоритетную поддержку или персонального менеджера.",
            "title": "Как связаться с&nbsp;командой поддержки?"
          },
          "supportTypes": {
            "answer": "<ul><li>Базовая: Предоставляет общую поддержку, включающую ответы на&nbsp;часто задаваемые вопросы и&nbsp;помощь по&nbsp;электронной почте.</li><li>Приоритетная: Обеспечивает более быстрый ответ на&nbsp;запросы и&nbsp;доступ к&nbsp;расширенной поддержке через удобные мессенджеры.</li><li>Персональный менеджер: Назначается персональный менеджер, который помогает с&nbsp;решением всех вопросов и&nbsp;координирует работу с&nbsp;сервисом.</li></ul>",
            "title": "Какие виды поддержек бывают?"
          }
        }
      },
      "sectionCards": {
        "createdInDonut": "Создано в Donut",
        "viewExample": "Посмотреть пример"
      },
      "validation": {
        "email": "Email должен содержать {'@'} и домен почтового клиента",
        "required": "Поле обязательное"
      }
    }
  },
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ru",
    "name": "Russian",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
